import theme from "theme";

import AvatarDropdownButton from "components/MainNavigation/AvatarDropdownButton";
import Logo from "components/MainNavigation/Logo";
import NavigationMenuList from "components/MainNavigation/NavigationMenuList";
import Paper from "components/Paper";
import Stack from "components/Stack";

import { useSignedUser } from "entities/Auth/sdk";
import BookmarksPopover from "entities/Bookmark/BookmarksPopover";
import NotificationsPopover from "entities/Notification/NotificationsPopover";

import ESignDocumentsButton from "./ESignDocumentsButton";

// Used for anchoring
export const ID = "main-navigation";

const MainNavigation = () => {
  const { data: user } = useSignedUser();

  return (
    <Paper
      square={true}
      id={ID}
      sx={{
        backgroundColor: "#181833",
        padding: theme.spacing(0, 1.5, 0, 4),
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={1}>
          <Logo />
          <NavigationMenuList />
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          data-testid="right-navigation-items"
        >
          {user?.memo_e_sign_documents_exist &&
            user.company_is_paying_customer && (
              <ESignDocumentsButton
                documentsCount={user.memo_e_sign_pending_documents_count}
              />
            )}
          <BookmarksPopover />
          <NotificationsPopover />
          <AvatarDropdownButton />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default MainNavigation;
